export const Check = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.7571 5.26405L21.7571 5.26407L21.7606 5.26056C21.9679 5.05323 22.2819 5.05323 22.4892 5.26056C22.7153 5.4866 22.6675 5.77225 22.5203 5.88674L22.5058 5.89798L22.4927 5.91075L9.41292 18.6157C9.20416 18.7926 9.01794 18.8665 8.77491 18.8665C8.51426 18.8665 8.30288 18.7814 8.14812 18.6267L8.14814 18.6266L8.14472 18.6233L1.51684 12.1827C1.32236 11.9564 1.32165 11.6445 1.50396 11.4548C1.73297 11.2575 2.05008 11.2589 2.23921 11.4481L2.24134 11.4502L8.54134 17.6377L8.77354 17.8657L9.00707 17.639L21.7571 5.26405Z"
        fill="#22AD5C"
        stroke="#22AD5C"
        strokeWidth="0.666667"
      />
    </svg>
  );
};
